import { gql } from "@apollo/client";

export const GET_NOTIFICATION_BY_ORGID = gql`
  query NotificationByOrg($orgId: Int) {
    notificationByOrg(orgId: $orgId) {
      Id
      title
      message
      orgId
      sendTo
      type
      visibility
      date
      createdBy
      createdAt
      employeeDetails {
        firstName
        lastName
      }
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation CreateNotification($input: createnotificationInput) {
    createNotification(input: $input) {
      title
      orgId
      message
    }
  }
`;

export const GET_NOTIFICATION_BY_ID = gql`
  query Notification($id: Int) {
    notification(Id: $id) {
      Id
      title
      message
      type
      visibility
      sendTo
      orgId
      readByUser
    }
  }
`;
export const GET_NOTIFICATION_BY_LATEST = gql`
  query NotificationOrgLatest($orgId: Int, $userId: String) {
    notificationOrgLatest(orgId: $orgId, userId: $userId) {
      Id
      title
      message
      type
      visibility
      orgId
      sendTo
      userId
      readByUser
    }
  }
`;

export const DASHBOARD_NOTIFICATION_ALL = gql`
  query dashboardNotificationAll($orgId: Int, $userId: String) {
    dashboardNotificationAll(orgId: $orgId, userId: $userId) {
      birthday
      anniversary
      jobNotification {
        readJobs
        unreadJobs
      }
      applicantNotification {
        readApplicants
        unreadApplicants
      }

    
      orglevelNotification {
        Id
        message
        readByUser
      }
    
 

     
     
      scheduleNotification {
        unreadInterviews
        readInterviews
      }
      shiftAssignNotification {
        readShifts
        unreadShifts
      }
     
      scheduleupdatedNotification
      interviewStatusapplicant
      surveyNotification {
        readSurveys
        unreadSurveys
      }
      taskendNotification {
        unreadTasks
        readTasks
      }
    
    
   
      taskAssignNotification

   
  
   voucherNotifications {
  message
}
      employeePerformanceNotification
      employeeSurveyAssignNotification
      paymentReminderNotifications {
        message
      }
    
    }
  }
`;

// export const DASHBOARD_NOTIFICATION_ALL = gql`
//   query dashboardNotificationAll(orgId:1) {
//     dashboardNotificationAll(orgId: $orgId) {
//        birthday
//       anniversary
//      }
//  }
// `;
export const UPDATE_NOTIFICATION = gql`
  mutation updateNotification($input: updatenotificationInput) {
    updateNotification(input: $input)
  }
`;
